import { render, staticRenderFns } from "./interpretacion.vue?vue&type=template&id=3f96a606&scoped=true"
import script from "./interpretacion.vue?vue&type=script&lang=js"
export * from "./interpretacion.vue?vue&type=script&lang=js"
import style0 from "./interpretacion.vue?vue&type=style&index=0&id=3f96a606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96a606",
  null
  
)

export default component.exports